import { render, staticRenderFns } from "./VersionUpdateSnackbars.vue?vue&type=template&id=962f9afe&"
import script from "./VersionUpdateSnackbars.vue?vue&type=script&lang=js&"
export * from "./VersionUpdateSnackbars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports